import * as Sentry from '@sentry/react';

if (process.env.MIX_SENTRY_JS_LOGS_ENABLED?.toLowerCase() === 'true') {
    Sentry.init({
        dsn: process.env.MIX_SENTRY_JS_DSN,
        tracesSampleRate: parseFloat(process.env.MIX_SENTRY_JS_TRACES_SAMPLE_RATE),
        release: process.env.MIX_SENTRY_JS_RELEASE || 'gglotto@dev',
        integrations: [
            Sentry.rewriteFramesIntegration({
                prefix: 'app:///',
                iteratee: (frame) => {
                    if (frame.filename) {
                        frame.filename = frame.filename
                            .replace(/\?id=\w+$/, '')
                            .replace(/^https?:\/\/[^\/]+/, 'app:///');
                    }
                    return frame;
                },
            }),
        ],
    });
}
